module.exports = __webpack_public_path__ + "static/media/banner3.0ed80e57.jpg";